import React from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';

const AboutPage = () => {
  return (
    <Container>
      <Row>
       <Col className='col-12 text-white py-3'>
       <h1 className='text-center text-success pt-1 fw-bold'>About US</h1>
      <p>Welcome to Get style, your one-stop online shop for all your needs. We are passionate about providing high-quality clothes,Electronics,Jewelery at affordable prices.</p>
      <p>At Get style, our mission is to buying user at Low price. We strive to bring joy and convenience to our customers' lives by offering a wide range of  0 to laks that are both stylish and functional.</p>
      <p>We believe in our Products Quality. Our team is dedicated to curating the best selection of Electronics,clothes and ensuring an exceptional shopping experience for every customer.</p>
      <p>With 5 + years in the  industry, we are proud to serve customers all around the world. Whether you're looking for need assistance with 24/7, our knowledgeable team is here to help.</p>
      <p>On our website, you will find a wide range of to suit every style and budget. We carefully select our products from trusted brands and strive to offer the latest trends and designs.</p>
      <p>Thank you for choosing Got Style. We value your trust and are committed to providing exceptional customer service. If you have any questions or feedback, please don't hesitate to reach out to our friendly support team.</p>
      <p>Happy shopping!</p>
       </Col>
      </Row>
    </Container>
  );
};

export default AboutPage;
